export enum RouterUriComponents {
  LIST_PAYFORMS = 'list-payforms',
  NOT_AUTHORIZED_PAGE = 'not-authorized',
  PAYFORM = 'payform',
  VIEW_PAYFORM = 'view-payform'
}
